<template>
  <div class="standard-page">
    <div class="detail-view-header">
      Account Detail
    </div>
    <div class="detail-view-deck">
      <b-card class="detail-view-info-card">
        <LabeledInfo
          label="Amount Due"
          :value="account.amount_due"
          type="money"
        />
        <LabeledInfo
          label="Minimum Payment"
          :value="account.minimum_payment"
          type="money"
        />
        <LabeledInfo
          label="Maximum Payment"
          :value="account.maximum_payment"
          type="money"
        />
        <LabeledInfo label="Due Date" :value="account.due_date" type="date" />
        <b-row>
          <b-col cols="4">
            <label>Customers:</label>
          </b-col>
          <b-col class="labeled-info-value" cols="8">
            <div v-for="customer in account.customers" :key="customer">
              {{ customer }}
            </div>
          </b-col>
        </b-row>
      </b-card>
      <b-card class="detail-view-info-card">
        <LabeledInfo label="ID" :value="account.id" />
        <LabeledInfo label="External ID" :value="account.external_id" />
      </b-card>
    </div>
  </div>
</template>

<script>
import endpoints from '@/utils/endpoints.js'

export default {
  data() {
    return {
      account: {}
    }
  },
  mounted() {
    this.getAccount()
  },
  methods: {
    getAccount() {
      this.axios
        .get(
          endpoints.retrieveAccount(
            this.$route.params.merchantID,
            this.$route.params.accountID
          )
        )
        .then(res => {
          this.account = res.data
        })
        .catch(err => {
          console.log('error', err)
        })
    }
  }
}
</script>
